import { CDS } from "design-system";
import type { GroupType } from "../types";

const VARIANT_BY_TYPE: Record<GroupType, "primary" | "success" | "warning" | "neutral"> = {
  team: "primary",
  department: "success",
  location: "warning",
  role: "neutral",
};

const LABEL_BY_TYPE: Record<GroupType, string> = {
  team: "Team",
  department: "Department",
  location: "Location",
  role: "Role",
};

interface GroupTypeTagProps {
  groupType: GroupType;
}

export default function GroupTypeTag({ groupType }: GroupTypeTagProps) {
  const variantKey = VARIANT_BY_TYPE[groupType] ?? "neutral";
  return (
    <CDS.Tag size={CDS.Tag.size.small} variant={CDS.Tag.variant[variantKey]}>
      {LABEL_BY_TYPE[groupType]}
    </CDS.Tag>
  );
}
